import { Location } from "@angular/common";
import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MenuService } from "../../core/menu/menu.service";

@Component({
  selector: "app-title",
  templateUrl: "./title.html",
  styleUrls: ["./title.scss"]
})
export class TitleComponent implements OnInit, OnDestroy {
  @Input() title;
  @Input() small;
  @Input() tooltip;
  @Input() svg;

  user;
  current;

  private destroy$ = new Subject<void>();

  constructor(public menuService: MenuService, public Location: Location) {}

  ngOnInit(): void {
    let localUser = localStorage.getItem("USER") || "";
    let user: any = <any>JSON.parse(localUser);
    this.user = user;

    const loc = this.Location.path().replace(/[0-9+/]/g, "");

    // Suscripción reactiva: resuelve el caso donde el menú aún no cargó al iniciar
    this.menuService.getMenu$().pipe(takeUntil(this.destroy$)).subscribe((menu) => {
      if (!menu || menu.length === 0) {
        return;
      }
      this.current = this.resolveCurrentMenuItem(menu, loc);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Busca el ítem del menú que corresponde a la ruta actual.
   * Cuando varios links coinciden como substring de la ruta (ej. "/waterwise"
   * dentro de "/calibracion-waterwise"), se prioriza el link más específico
   * (el más largo) en lugar del primero encontrado.
   * @param menu - Lista de ítems del menú
   * @param loc - Ruta actual sin segmentos numéricos
   * @returns El ítem del menú que coincide con la ruta, o undefined si no hay coincidencia
   */
  private resolveCurrentMenuItem(menu: any[], loc: string): any {
    const include = (text: string, link: string) => text.includes(link);
    const stripSlash = (text: string) => text.replace(/\//g, "");

    const matchLength = (item: any): number => {
      if (!item.link) {
        return -1;
      }
      const link = stripSlash(item.link);
      return include(loc, link) ? link.length : -1;
    };

    const bestMatch = (array: any[]) => {
      let best: any;
      let bestLength = -1;
      array.forEach((item) => {
        const length = item.submenu
          ? Math.max(...item.submenu.map((sub: any) => matchLength(sub)))
          : matchLength(item);
        if (length > bestLength) {
          bestLength = length;
          best = item;
        }
      });
      return bestLength >= 0 ? best : undefined;
    };

    const selected = bestMatch(menu);
    if (selected && selected.submenu && selected.submenu.length > 0) {
      return bestMatch(selected.submenu);
    }
    return selected;
  }
}
